import { render, staticRenderFns } from "./get_started.vue?vue&type=template&id=24cd990e&"
import script from "./get_started.vue?vue&type=script&lang=js&"
export * from "./get_started.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports